const assetBaseUrl = 'https://assets.fastcompany.com/image/upload/';
const cloudinaryPresets = `w_387,q_auto,f_auto,fl_lossy/`;

// for the asset, change only the image path, not the constants above ^^
const imagePath = 'v1498142779/fcweb/mic-2018-banner-387_imq1i8.png';

const data = {
  assetUrl: `${assetBaseUrl}${cloudinaryPresets}${imagePath}`,
  link:
    'https://www.fastcompany.com/apply/most-innovative-companies?utm_source=homepage&utm_medium=web&utm_campaign=mic_apply_0622',
  alt: 'Most Innovative Companies 2018',
  width: 387,
  height: 100
};

export default data;



// WEBPACK FOOTER //
// ./src/views/components/scrolling_module_promo/scrolling_module_promo_model.js